import axios from 'axios';
import apiUrl from '../../api.config';

const CLASS_GROUP_API_URL = `${apiUrl}classGroup`;

class ClassGroupService {
   add(classGroupData) {
    return axios.post(CLASS_GROUP_API_URL + "/add", classGroupData, {
      headers: {
        'x-access-token': `${localStorage.getItem('accessToken')}`
      }
    });
  }

   findAll() {
    return axios.get(CLASS_GROUP_API_URL + "/get", {
      headers: {
        'x-access-token': `${localStorage.getItem('accessToken')}`
      }
    });
  }

   findBySchool() {
    return axios.get(`${CLASS_GROUP_API_URL}/bySchool/`, {
      headers: {
        'x-access-token': `${localStorage.getItem('accessToken')}`
      }
    });
  }

   update(id, updateData) {
    return axios.put(`${CLASS_GROUP_API_URL}/update/${id}`, updateData, {
      headers: {
        'x-access-token': `${localStorage.getItem('accessToken')}`
      }
    });
  }

   delete(id) {
    return axios.delete(`${CLASS_GROUP_API_URL}/delete/${id}`, {
      headers: {
        'x-access-token': `${localStorage.getItem('accessToken')}`
      }
    });
  }
}

export default new ClassGroupService();